import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import $ from "jquery";
import Select from "react-select";

const department = [
    { value: 'زانستی', label: 'زانستی' },
    { value: 'وێژەیی', label: 'وێژەیی' },
];

// Rows are injected by DataTables as HTML, and the values come from a public form,
// so every value has to be escaped on the way in.
const escapeHtml = (value) => String(value === null || value === undefined ? '' : value)
    .replace(/[&<>"']/g, (chr) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[chr]));

const feather = (paths) => `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
const EDIT_ICON = feather('<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>');
const TRASH_ICON = feather('<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>');

const Submition = ({ icon }) => {

    const tableRef = useRef(null);
    const tableApi = useRef(null);
    const [editing, setEditing] = useState(null);

    const reload = (resetPaging) => tableApi.current && tableApi.current.ajax.reload(null, resetPaging);

    useEffect(() => {
        const table = tableRef.current;

        // serverSide: searching, sorting and paging all happen in MySQL, so the browser
        // only ever holds one page of rows no matter how large the table grows.
        const dt = window.$(table).DataTable({
            serverSide: true,
            processing: true,
            responsive: true,
            deferRender: true,
            searchDelay: 400,
            order: [],
            pageLength: 25,
            lengthMenu: [10, 25, 50, 100],
            ajax: { url: '/auth/submition' },
            columns: [
                {
                    data: null, orderable: false, searchable: false,
                    render: (value, type, row, meta) => meta.row + meta.settings._iDisplayStart + 1
                },
                { data: 'full_name', render: escapeHtml },
                { data: 'phone_no', render: escapeHtml },
                { data: 'department', render: escapeHtml },
                { data: 'created', render: (value) => value ? new Date(value).toLocaleDateString() : '' },
                {
                    data: null, orderable: false, searchable: false, className: 'text-nowrap d-print-none',
                    // One shared modal is reused for every row, so the row itself only
                    // carries the values the edit form needs.
                    render: (value, type, row) => `
                        <button type="button" class="btn btn-sm btn-outline-success mx-1 js-edit"
                            data-id="${escapeHtml(row.id)}"
                            data-full_name="${escapeHtml(row.full_name)}"
                            data-phone_no="${escapeHtml(row.phone_no)}"
                            data-department="${escapeHtml(row.department)}">${EDIT_ICON}</button>
                        <button type="button" class="btn btn-sm btn-outline-danger js-delete"
                            data-id="${escapeHtml(row.id)}">${TRASH_ICON}</button>`
                }
            ]
        });
        tableApi.current = dt;

        window.$(table).on('click.submition', '.js-edit', function () {
            setEditing({ ...this.dataset });
        });

        window.$(table).on('click.submition', '.js-delete', function () {
            const id = this.dataset.id;
            Swal.fire({
                title: 'هشیاربە !',
                text: "پشتی داتا هاتە ژێربن تو نەشێی زڤرینی",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ژێبرن',
                cancelButtonText: 'داخستن'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`/auth/submition/${id}`).then(() => {
                        toast.success('هاتە ژێبرن');
                        reload(false);
                    })
                }
            })
        });

        $('.nav-item').removeClass('active');
        $('.nav-item').each(function () {
            if ($(this).find('a').attr('href') === window.location.pathname) {
                $(this).addClass('active');
            }
        });

        return () => {
            window.$(table).off('click.submition');
            dt.destroy();
            tableApi.current = null;
        };
    }, []);

    useEffect(() => {
        if (editing) window.$('#edit').modal('show');
    }, [editing]);

    useEffect(() => {
        const modal = document.getElementById('edit');
        const clear = () => setEditing(null);
        modal.addEventListener('hidden.bs.modal', clear);
        return () => modal.removeEventListener('hidden.bs.modal', clear);
    }, []);

    return (
        <div className="page-content">
            <nav className="page-breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">دەستپێک</a></li>
                    <li className="breadcrumb-item active" aria-current="page">تومارا فورمی</li>
                </ol>
            </nav>
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <h6 className="card-title">تۆمارا فورمی</h6>
                                </div>
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button type="button" className="btn btn-sm btn-outline-dark mx-2" onClick={() => window.print()}>
                                        <icon.Printer />
                                        <span className="ms-2">چاپکرن</span>
                                    </button>
                                    <button className="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#new">
                                        <icon.Plus />
                                        <span className="ms-2">قوتابیەک نوی</span>
                                    </button>
                                    <div className="modal fade" id="new" tabIndex={-1} aria-labelledby="new" aria-hidden="true">
                                        <div className="modal-dialog modal-lg">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">قوتابیەک نوی</h5>
                                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                </div>
                                                <form onSubmit={(e) => {
                                                    e.preventDefault();
                                                    const form = e.target;
                                                    const data = Object.fromEntries(new FormData(form));
                                                    axios.post(`/auth/submition`, data).then(() => {
                                                        window.$(`#new`).modal('hide');
                                                        form.reset();
                                                        toast.success('هاتە زێدەکرن');
                                                        reload(true);
                                                    })
                                                }} >
                                                    <div className="modal-body">
                                                        <div className="mb-3">
                                                            <label className="form-label">ناڤێ سیانی</label>
                                                            <input type="text" className="form-control" name="full_name" placeholder=" ناڤێ قوتابی..." required />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">ژ.مۆبایل</label>
                                                            <input type="text" className="form-control" name="phone_no" placeholder=" ناڤێ قوتابی..." required />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">پشک</label>
                                                            <Select options={department} name="department" placeholder="پشکا قوتابی دیاربکە ..." required />
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">داخستن</button>
                                                        <button type="submit" className="btn btn-primary">زێدەکرن</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table ref={tableRef} className="table table-striped table-sm dt-tbl print" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>قوتابی</th>
                                        <th>ژ.مۆبایل</th>
                                        <th>پشک</th>
                                        <th>رێککەفت</th>
                                        <th className="d-print-none">بژاردە</th>
                                    </tr>
                                </thead>
                                <tbody />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="edit" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">دەستکاریکرن</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        {editing && (
                            <form key={editing.id} onSubmit={(e) => {
                                e.preventDefault();
                                const data = Object.fromEntries(new FormData(e.target));
                                axios.put(`/auth/submition/${editing.id}`, data).then(() => {
                                    window.$(`#edit`).modal('hide');
                                    toast.success('نویکرایەوە');
                                    reload(false);
                                })
                            }} >
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">ناڤێ سیانی</label>
                                        <input type="text" className="form-control" name="full_name" defaultValue={editing.full_name} required />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">ژ.مۆبایل</label>
                                        <input type="text" className="form-control" name="phone_no" defaultValue={editing.phone_no} required />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">پشک</label>
                                        <Select options={department} name="department" defaultValue={{ value: editing.department, label: editing.department }} required />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">داخستن</button>
                                    <button type="submit" className="btn btn-primary">نویکرن</button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Submition;
